module.exports = __webpack_public_path__ + "static/media/logo-sm-dark.f093577d.png";